module.exports = __webpack_public_path__ + "img/mail-task.157de58b.svg";